import { __awaiter } from "tslib";
import { getActiveNotificationIdFromCookie } from 'pathfinder/modules/MarketingNotifications/helpers/activeNotification';
import { dwTracker } from 'pathfinder/modules/MarketingNotifications/hooks/useNotificationsTracking';
import { MarketingNotificationModule } from 'pathfinder/modules/MarketingNotifications/MarketingNotificationModule';
import { isNotificationBanner } from 'pathfinder/modules/MarketingNotifications/utils/checkBannerNotification';
import { selectNotification } from 'pathfinder/modules/MarketingNotifications/utils/selectNotification';
import { buildModuleProps } from 'pathfinder/rules-engine/moduleProps';
import { DAY_PERIOD, getLastAction } from 'pathfinder/utils/actionsHelper';
import React from 'react';
import ReactDOM from 'react-dom';
import isMobile from 'utils/isMobile';
import waitForConsent from 'utils/waitForConsent';
function listenOnOdysseyAdFloorAdhesion(log, reactRoot) {
    const isOdysseyEnabled = document.body.classList.contains('odyssey');
    if (isOdysseyEnabled) {
        log.debug('Notification: Odyssey enabled, listening for floor_adhesion ad');
        const observer = new MutationObserver(() => {
            const floorAdhesion = document.getElementById('floor_adhesion');
            if (floorAdhesion) {
                const height = floorAdhesion.clientHeight;
                reactRoot.style.bottom = `${height}px`;
            }
            else {
                reactRoot.style.bottom = '0px';
            }
        });
        observer.observe(document.body, { childList: true, subtree: true });
    }
}
export const getMarketingNotificationsModuleMethods = (moduleConfig) => __awaiter(void 0, void 0, void 0, function* () {
    const hasNotificationsDisabled = window.mw.config.get('wgDisableCMSNotifications');
    const isMobileDevice = Boolean(isMobile());
    const moduleProps = buildModuleProps(moduleConfig, {
        isMobile: isMobileDevice,
        moduleName: moduleConfig.type,
        hasAnonMobileNotificationsEvent: true,
    });
    const { log } = moduleProps;
    if (hasNotificationsDisabled) {
        log.debug('Notification: not displayed due to disable notification flag');
        return null;
    }
    const activeNotificationId = parseInt(getActiveNotificationIdFromCookie());
    const isActiveNotificationUnavailable = isNaN(activeNotificationId) || activeNotificationId === -1;
    if (isActiveNotificationUnavailable) {
        const action = yield getLastAction(moduleConfig.type, window.SilverSurferSDK.ACTION.IMPRESSION);
        const lastImpressionTimestamp = (action === null || action === void 0 ? void 0 : action.time) || 0;
        const now = Date.now();
        const isOlderThanDay = now - lastImpressionTimestamp > DAY_PERIOD;
        if (!isOlderThanDay) {
            log.debug('Notification: not displayed due to 24h rule');
            return null;
        }
    }
    try {
        yield waitForConsent();
    }
    catch (err) { }
    const isBannerNotificationVisible = isNotificationBanner();
    if (isBannerNotificationVisible) {
        return;
    }
    let selectedNotification = yield selectNotification();
    if (!selectedNotification) {
        log.debug('Nothing to display');
        if (!moduleConfig.internalState.forced) {
            return null;
        }
        selectedNotification = (yield import(/* webpackChunkName: "marketingNotification-forcedModuleData" */ './utils/forcedModuleNotification')).default;
        log.debug('Forced to display, loaded default notification');
    }
    log.debug('Selected notification', selectedNotification);
    moduleProps.notification = selectedNotification;
    try {
        const reactRoot = document.createElement('div');
        reactRoot.classList.add('marketing-notifications');
        const notificationsContainer = isMobileDevice
            ? document.querySelector('.notifications-box')
            : document.querySelector('.notifications-placeholder');
        if (notificationsContainer) {
            reactRoot.style.position = 'relative';
            if (!isMobileDevice) {
                reactRoot.style.width = '368px';
            }
            // listen and react to the Odyssey floor_adhesion ad
            // this will move the notification up by the height of the ad
            if (!isMobileDevice) {
                listenOnOdysseyAdFloorAdhesion(log, reactRoot);
            }
            notificationsContainer.insertAdjacentElement('afterbegin', reactRoot);
        }
        const render = () => {
            ReactDOM.render(React.createElement(MarketingNotificationModule, moduleProps), reactRoot);
            dwTracker({
                action: 'inserted',
                label: selectedNotification.id.toString(),
                name: selectedNotification.name,
                author: selectedNotification.created_by,
            });
            return reactRoot;
        };
        return {
            render,
        };
    }
    catch (error) {
        log.debug('MarketingNotifications error', error);
    }
    return null;
});
